import React, { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { projects } from '../data/projects';
import '../styles/v3-projects.css';

const FILTERS = [
    { id: 'all', label: 'ALL' },
    { id: 'vr', label: 'XR' },
    { id: 'ai', label: 'AI' },
    { id: 'simulation', label: 'OTHER' },
];

// Headline projects, shown first as full-size cards.
const TIER1_IDS = [1, 3, 5]; // Gorilla vs 100 Men, BookWorm, Chotu

function ProjectCard({ project, index }) {
    return (
        <Link to={`/project/${project.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
            <motion.div
              className="v3-portfolio-card"
              data-block-color={project.blockColor}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-50px' }}
              transition={{ duration: 0.4, delay: index * 0.06, ease: [0.22, 1, 0.36, 1] }}
              whileHover={{ y: -4 }}
            >
                <div className="v3-portfolio-card__shot">
                    <img src={project.image} alt={project.title} />
                </div>
                <div className="v3-portfolio-card__category">{project.category}</div>
                <h3 className="v3-portfolio-card__title">{project.title}</h3>
                <p className="v3-portfolio-card__description">{project.shortDescription}</p>
                <div className="v3-portfolio-card__link">→ READ THE TEARDOWN</div>
            </motion.div>
        </Link>
    );
}

function Portfolio() {
    const [filter, setFilter] = useState('all');

    const filteredProjects = useMemo(
        () => (filter === 'all' ? projects : projects.filter((p) => p.tags.includes(filter))),
        [filter]
    );

    const tier1 = filteredProjects.filter((p) => TIER1_IDS.includes(p.id));
    const tier2 = filteredProjects.filter((p) => !TIER1_IDS.includes(p.id));

    return (
        <section className="v3-portfolio" id="portfolio" data-aos="fade-up" data-aos-duration="1000">
            <div className="v3-portfolio__eyebrow">[ SELECTED WORK · 2024 – 2026 ]</div>
            <h2 className="v3-portfolio__heading">Selected Work.</h2>

            <div className="v3-portfolio__filters">
                {FILTERS.map((f) => (
                    <button
                        key={f.id}
                        className={`v3-portfolio__pill ${filter === f.id ? 'v3-portfolio__pill--active' : ''}`}
                        onClick={() => setFilter(f.id)}
                    >
                        [ {f.label} ]
                    </button>
                ))}
            </div>

            {tier1.length > 0 && (
                <div className="v3-portfolio__grid">
                    {tier1.map((project, index) => (
                        <ProjectCard key={project.id} project={project} index={index} />
                    ))}
                </div>
            )}

            {tier2.length > 0 && (
                <>
                    <div className="v3-portfolio__tier2-heading">
                        [ MORE WORK · {tier2.length} PROJECT{tier2.length === 1 ? '' : 'S'} ]
                    </div>
                    <div className="v3-portfolio__grid v3-portfolio__grid--compact">
                        {tier2.map((project, index) => (
                            <ProjectCard key={project.id} project={project} index={index} />
                        ))}
                    </div>
                </>
            )}
        </section>
    );
}

export default Portfolio;
